<app-header />

<main class="app-main" id="main-content" tabindex="-1">
  <router-outlet />
</main>
